import ContentWrapper from "./content-wrapper.container";

export default ContentWrapper;
